<script>
import useTools from "@/use/Tools";
import axios from "axios";
import {computed, onMounted, ref} from "vue";

export default {
    props: {
        disabled: Boolean
    },
    setup(props, {emit}) {
        const {$refs, $route} = useTools();

        const loading = ref(false);
        const dialog = ref(false);
        const files = ref([]);

        const totalReady = ref(0);
        const totalNotReady = ref(0);
        const loadingTotal = ref(false);

        const percent = computed(() => {
            return (
                (totalReady.value * 100) /
                (totalNotReady.value + totalReady.value)
            ).toFixed(0);
        });

        function countInQueue() {
            if (!props.disabled) {
                loadingTotal.value = true;
                axios
                    .get("/cvTechSourcings/countInQueue", {
                        params: {
                            sourcingId: $route.params.id,
                            state: "FOLDER_QUEUE",
                            source: "FOLDER"
                        }
                    })
                    .then(response => {
                        totalReady.value = response.data.totalReady;
                        totalNotReady.value = response.data.totalNotReady;
                        if (totalReady.value > 0 && totalNotReady.value === 0) {
                            upload();
                        }
                    })
                    .finally(() => {
                        loadingTotal.value = false;
                    });
            }
        }

        function uploadFiles() {
            $refs.fileInput.$el.querySelector("input").click();
        }

        function manualUpload() {
            loading.value = true;
            const formData = new FormData();
            for (let i = 0; i < files.value.length; i++) {
                formData.append("files", files.value[i]);
            }
            axios
                .post(`/cvTechSourcings/manualUpload/${$route.params.id}`, formData)
                .then(() => {
                    countInQueue();
                    files.value = [];
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        function upload() {
            loading.value = true;
            axios
                .post(`/cvTechSourcings/uploadFromFolder/${$route.params.id}`)
                .then(response => {
                    emit("upload", response.data);
                    // countInQueue();
                    dialog.value = false;
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        let intervalId;

        onMounted(() => {
            intervalId = setInterval(() => {
                countInQueue();
            }, 2000);
        });

        countInQueue(() => {
            clearInterval(intervalId);
        });

        return {
            loading,
            dialog,
            loadingTotal,
            totalReady,
            totalNotReady,
            percent,
            files,
            upload,
            uploadFiles,
            manualUpload
        };
    }
};
</script>

<template>
    <div>
        <v-dialog v-model="dialog" persistent scrollable max-width="500">
            <v-card>
                <w-toolbar
                    color="teal"
                    :title="$t('recruitment_request.sourcing_folder_title')"
                />
                <v-card-text>
                    <v-container fluid>
                        <h4>
                            <span class="blue--text">{{ totalReady }}</span>
                            {{ $t("recruitment_request.sourcing_folder_description") }}
                        </h4>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn
                        color="teal"
                        icon="mdi-database-import"
                        :text="$t('common.import')"
                        :loading="loading"
                        @press="upload"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-file-input
            ref="fileInput"
            v-model="files"
            accept=".pdf"
            multiple
            @change="manualUpload"
            outlined
            dense
            v-show="false"
        ></v-file-input>
        <v-badge color="blue" bordered overlap left :content="totalReady">
            <v-btn
                class="white--text ml-2"
                depressed
                small
                :disabled="disabled"
                :loading="totalNotReady > 0 && percent < 100"
                color="teal"
                @click="uploadFiles"
            >
                {{ $t('recruitment_request.folder') }}
                <v-icon right>mdi-folder</v-icon>
            </v-btn>
        </v-badge>
        <v-progress-circular
            v-if="totalNotReady > 0 && percent < 100"
            class="ml-1"
            :rotate="360"
            :size="38"
            :width="3"
            :value="percent"
            color="teal"
        >
            {{ percent }}
        </v-progress-circular>
    </div>
</template>